export default __webpack_public_path__ + "static/media/slot-active-m.59b45576.svg";